import PropTypes from 'prop-types'
import React from 'react'

import s from './UnstyledButton.module.scss'

export default function UnstyledButton({ children, onClick, className = '', ariaLabel, type = 'button' }) {
  return (
    <button aria-label={ariaLabel} className={`${s['unstyled-button']} ${className}`} onClick={onClick} type={type}>
      {children}
    </button>
  )
}

UnstyledButton.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
}
